module.exports = __webpack_public_path__ + "img/56-Black Cherry - Merisier.jpg";